import { Component, PropsWithChildren, cloneElement, createElement, createRef, isValidElement } from 'react';
import classNames from 'classnames';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { SpotSvg } from '../SpotSvg';

interface ReactBootstrapDaterangepickerProps {
    alwaysShowCalendars?: any;
    applyClass?: any;
    autoApply?: any;
    autoUpdateInput?: any;
    buttonClasses?: any;
    cancelClass?: any;
    dateLimit?: any;
    drops?: any;
    endDate?: any;
    isCustomDate?: any;
    isInvalidDate?: any;
    linkedCalendars?: any;
    locale?: any;
    maxDate?: any;
    minDate?: any;
    opens?: any;
    parentEl?: any;
    ranges?: any;
    showCustomRangeLabel?: any;
    showDropdowns?: any;
    showISOWeekNumbers?: any;
    showWeekNumbers?: any;
    singleDatePicker?: any;
    startDate?: any;
    template?: any;
    timePicker?: any;
    timePicker24Hour?: any;
    timePickerIncrement?: any;
    timePickerSeconds?: any;
    // Event callbacks (direct props in v8, not inside initialSettings)
    onApply?: (event: any, picker: any) => void;
    onShow?: (event: any, picker: any) => void;
    onHide?: (event: any, picker: any) => void;
    onShowCalendar?: (event: any, picker: any) => void;
    onHideCalendar?: (event: any, picker: any) => void;
    onCancel?: (event: any, picker: any) => void;
    onCallback?: (...args: any[]) => void;
    onEvent?: (event: any, picker: any) => void;
}

export interface SpotDatePickerProps extends ReactBootstrapDaterangepickerProps {
    bordered?: boolean;
    fixedWidth?: string;
    children: JSX.Element;

    [key: string]: any;
}

export interface SpotDatePickerState {
    isOpen?: boolean;
    contentWidth?: number;
}

export class SpotDatePicker extends Component<PropsWithChildren<SpotDatePickerProps>, SpotDatePickerState> {
    static defaultProps = {
        bordered: false,
        noPrompt: false,
    };

    state: SpotDatePickerState = {
        isOpen: false,
        contentWidth: 0,
    };
    private widthRef: any;

    constructor(props) {
        super(props);
        this.widthRef = createRef();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.contentWidth !== this.widthRef.current.clientWidth) {
            this.setState({ contentWidth: this.widthRef.current.clientWidth });
        }
    }

    render() {
        const { fixedWidth, children, className, bordered,
            onApply, onShow, onHide, onShowCalendar, onHideCalendar, onCancel, onCallback, onEvent,
            ...settings } = this.props;
        return (
            <DateRangePicker
                initialSettings={{
                    buttonClasses: ['spot-button', 'spot-button--secondary', 'spot-button--small', 'date-picker-buttons'],
                    opens: 'right',
                    ...settings,
                }}
                onApply={onApply}
                onShow={onShow}
                onHide={onHide}
                onShowCalendar={onShowCalendar}
                onHideCalendar={onHideCalendar}
                onCancel={onCancel}
                onCallback={onCallback}
                onEvent={onEvent}
            >
                <div
                    className={classNames('dropdown-wrapper-outer', { 'dropdown-bordered': bordered }, className)}
                    style={{ width: !!this.state.contentWidth ? this.state.contentWidth : 'auto' }}
                >
                    <span className={`dropdown-wrapper-inner${this.state.isOpen ? '-selected' : ''}`} style={{ margin: 0 }}>
                        <span className="dropdown-header" style={{ padding: 0 }} ref={this.widthRef}>
                            <span className={fixedWidth ? 'fixed-width' : ''} style={{ width: this.props.fixedWidth }}>
                                {isValidElement(children) ? cloneElement(children) : createElement(children as any)}
                                <SpotSvg icon="caret-down" width="12px" height="12px" />
                            </span>
                        </span>
                    </span>
                </div>
            </DateRangePicker>
        );
    }
}
